import React from 'react';
import PropTypes from 'prop-types';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';

class SMUReservationPaymentView extends React.Component {
  
  formDidSubmit(e){
    e.preventDefault();
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
  }
  
  render() {
    let reservation = this.props.reservation;
    return (
      <div ref="form" className="form-casette maincol-lightbox__form">
        <h2 className="dashboard-title mb30 ta-c" 
          dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000038")}} />
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <div className="form-box">
            <h3 className="dashboard-title mb20">
              <span className="icon-form icon-form__required">必須</span>
              {I18n.t("dashboard.label_000191")}
              <span className="dashboard-title__supplement ml15">{I18n.t("dashboard.text_000029")}</span>
            </h3>
            <div className="mb20">
              <p className="dashboard-title2">クレジットカード</p>
            </div>

            <div ref="form-radio01__05" className="dashboard-message__info mt10">
              <input type="radio" value="1" id="form-radio01__01" name="lost_reason_type" />
              <label htmlFor="form-radio01__01" className="form-radio__s">登録カード</label><br />
              <input type="radio" value="1" id="form-radio01__01" name="lost_reason_type" />
              <label htmlFor="form-radio01__01" className="form-radio__s">新しいカード</label><br />
              <div className="form-box">
                <input type="text" className="form-text w60 mr5" />
                <input type="text" className="form-text w60 mr5" />
                <input type="text" className="form-text w60 mr5" />
                <input type="text" className="form-text w60 mr5" />
              </div>
            </div>
            <input type="radio" value="5" id="form-radio01__05" name="lost_reason_type" />
            <label htmlFor="form-radio01__05" className="form-radio__s">銀行振込</label>
          </div>
          <div className="ta-c mb30">
            <SMFormSubmitButton 
              title={I18n.t("dashboard.label_000108")} 
              options={{className: "button-green maincol-buttonarea__button"}} />
          </div>
        </form>
      </div>
    );
  }
}

SMUReservationPaymentView.propTypes = {
  reservation: PropTypes.object.isRequired
};

export default SMUReservationPaymentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationPaymentView.jsx